export default {
      id: "ic_arrow_down_white-usage",
      viewBox: "0 0 10 6",
      url: "/" + "images/icons.3.109.2.svg#ic_arrow_down_white-usage",
      toString: function () {
        return this.url;
      }
    }